module.exports = __webpack_public_path__ + "static/img/特殊说明.3d43a6ba.png";